var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_c('div',{staticClass:"container-fixed"},[_c('div',{staticClass:"box"},[_c('ProductList',{attrs:{"filter":_vm.filter,"sort":_vm.sort,"currentPage":_vm.currentPage},on:{"change":_vm.handleListChange}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }